/*
Helper method to set up for intercepting API requests/responses
*/

import axios from 'axios'

let navigatedToAuthentication = false

export default function setup () {
  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    // Redirect to login if not authenticated yet
    if (error.response.status === 401) {
      if (!navigatedToAuthentication) {
        navigatedToAuthentication = true

        const currentLocation = encodeURI(window.location.pathname + window.location.hash)
        window.location.href = `/Auth/SSO/DOE_SSO.php?source=${currentLocation}`
      }

      return {} // don't trigger uncaught error
    }
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js